<template>
  <div class="content" :class="share == 1 ? 'p50' : ''">
    <div class="modular" v-for="(item, index) in list" :key="index">
      <div class="title">
        <div class="title-line"></div>
        <div>{{ item.title }}</div>
      </div>
      <div class="txt">
        {{ item.content }}
      </div>
    </div>
    <!-- <div class="modular">
      <div class="title">
        <div class="title-line"></div>
        <div>属鼠2021年运势及运程-2021年属鼠人的全年每月 运势</div>
      </div>
      <div class="txt">
        2021为辛丑牛年，而鼠与牛恰好又呈现出六合的关系，因此这一年，属鼠人的综合运势可以表现得相当强劲，值得期待。吉星方面，主要有“文昌”和“岁合”，能够持续发挥力量，带来很多好的事情；凶星方面，则有“病符”和“陌越”，千万不能大意，要提高警惕心，以免被疾病打倒。在六合年份中，属鼠人要鼓足干劲，不管是学业还是事业，都要争取达到更高的境界。当然也别太洋洋得意，即便运势再过旺盛，也不可能不遇到挫折和困难，所以还是应当做好心理防备。
      </div>
    </div> -->
    <shareBottomComp v-if="share == 1"></shareBottomComp>
  </div>
</template>

<script>
/**
@description:星座详情
@createTime:2021-08-24
@create:wq
*/
import { shareJsSdk, HERF, getQueryString } from "@/utils/tool";
import shareBottomComp from "@/components/shareBottomComp";
export default {
  name: "",
  props: {},
  components: { shareBottomComp },
  data() {
    return {
      id: "",
      list: [],
      share: 0,
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  created() {
    this.id = this.$route.query.id
      ? this.$route.query.id
      : getQueryString("id");
    if (getQueryString("share")) {
      this.share = 1;
    } else {
      this.share = 0;
    }
    this.getData();
  },
  methods: {
    getData() {
      this.api.fortuneDetails({ id: this.id }).then((res) => {
        this.list = res.data;
        let t = this.list.length > 0 ?  this.list[0].name + '运势详解' : '可以测星座'
        shareJsSdk("xzdetails", t, "", this.id,this.list[0].icon);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  overflow: hidden;
  .modular {
    margin: 0.2rem 0.24rem;
  }
}
.title {
  font-size: 0.3rem;
  color: #41beb7;
  display: flex;

  .title-line {
    margin-top: 4px;
    width: 0.08rem;
    height: 0.34rem;
    background: linear-gradient(180deg, #4fd9d5 0%, #2fb1ad 100%);
    border-radius: 0px 2px 2px 0px;
    margin-right: 0.22rem;
  }
}
.txt {
  font-size: 0.24rem;
  color: #999999;
  margin-top: 0.16rem;
}
</style>
